import styled from 'styled-components'

export const PaymentWrapper = styled.div`
  padding: 0 1rem 1rem;
`
